<template>
  <b-col cols="12">

    <div class="main-card card p-2 h-100-header" id="container_pages">

      <div class="card-body" id="card-page">

        <b-row v-if="breadcrumb">
          <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
        </b-row>

        <slot name="title">
          <t-page-title :title="currentPage.pageTitle">
            <slot name="title-buttons"></slot>
          </t-page-title>
        </slot>

        <div class="mt-4">

          <slot>

          </slot>

        </div>

      </div>

    </div>
  </b-col>
</template>
<style>
</style>
<script>
export default {
  name: 't-page-general',
  props: {
    currentPage: Object,
    userAuth: Object,
    breadcrumb: Array
  },
  data() {
    return {
      localIsLoadingPage: false,
    }
  },
  mounted() {

  },
  methods: {},
  computed: {

  },
  watch: {},
}
</script>
